// utils/mdUtils.js

import MarkdownIt from 'markdown-it';


export const MarkdownStyles = `
        .markdown-content h1, .markdown-content h2, .markdown-content h3,
        .markdown-content h4, .markdown-content h5, .markdown-content h6 {
            margin-bottom: 1rem;
        }
        .markdown-content hr {
            height: 1px;
            // background-color: #e6e6e6 !important; /* Your desired border color */
            margin: 2rem -2rem 2rem -2rem; /* Adjust as needed */
            border: none; /* Ensures no default border interferes */
        }
        
        .markdown-content h1 {
          font-size: 1.8rem;  /* Your base size */
          font-weight: 700!important;
          margin-left: -2.5px; /* Adjust this value as needed */


        }
        
        .markdown-content h2 {
          font-size: calc(1.8rem * 0.83); /* ~1.5rem */
          font-weight: 600;
          margin-left: -2.5px; /* Adjust this value as needed */

        }
        
        .markdown-content h3 {
          font-size: calc(1.8rem * 0.67); /* ~1.2rem */
          font-weight: 600; 
        }
        
        .markdown-content h4 {
          font-size: calc(1.8rem * 0.5);  /* ~0.9rem */
          
        }
        
        .markdown-content h5 {
          font-size: calc(1.8rem * 0.33); /* ~0.6rem */
        }
        
        .markdown-content h6 {
          font-size: calc(1.8rem * 0.25); /* ~0.45rem */
        }
        .markdown-content table {
          width: 100%; /* Ensure the table takes up the full width of its container */
          border-collapse: collapse; /* Collapse borders for a cleaner look */
          margin-bottom: 1rem; /* Add some space below the table */
        }
        
        .markdown-content th, 
        .markdown-content td {
          text-align: left; /* Left-align text within cells */
          padding: 0.5rem; /* Add padding to cells */
          border: 1px solid #eee; /* Add very light gray borders */
        }
        .markdown-content p, /* Target paragraphs */
            .markdown-content li, /* Target list items */
            .markdown-content blockquote { /* Target blockquotes */
              color: #334155; /* Set the desired text color */
        }
        
  
    `;


// Reuse your existing code:
const tickerRegex = /\b([A-Z]{2,4})\b/g;

function linkTickers(text) {
  return text.replace(tickerRegex, (match, symbol) => {
    // Generates an HTML <a> tag with inline color style
    return `<a href="/tickers/${symbol}" style="color: blue;">${symbol}</a>`;
  });
}

// Create the function that handles problem characters
// and injects ticker links, etc.
function sanitizeMarkdownText(text) {
  const characterMap = {
    'â': "'",
    'â¦': '...',
    'â¢': '*',
    'Â': ' ',
    '•': '•',
    '\u8226': '•',
    'ʼ': "'",
    '\u2018': "'",
    '\u2019': "'",
    '\u201C': '"',
    '\u201D': '"',
    '\uFFFD': '',
  };

  // Escape markdown special characters if needed
  const escapeMarkdownChars = (str) => {
    const markdownChars = /[\\`*_{}[\]()#+-.!]/g;
    return str.replace(markdownChars, '\\$&');
  };

  // Replace the problematic unicode chars
  let sanitized = text;
  for (const [char, replacement] of Object.entries(characterMap)) {
    sanitized = sanitized.replace(new RegExp(char, 'g'), replacement);
  }

  // Remove all non-ASCII (optional)
  // sanitized = sanitized.replace(/[^\x00-\x7F]+/g, '');

  // Optionally escape Markdown
  sanitized = escapeMarkdownChars(sanitized);

  // Link tickers
  sanitized = linkTickers(sanitized);

  return sanitized;
}

// Create and configure a single MarkdownIt instance
export const mdParser = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true,
  typographer: true,
  quotes: '“”‘’'
});

/**
 * parseAndSanitizeMarkdown
 *  - Replaces code fences or unwanted markers
 *  - Sanitizes text
 *  - Renders it to HTML using MarkdownIt
 */
export function parseAndSanitizeMarkdown(rawText) {
  if (!rawText) return '';

  // For example, remove ```html or other code fence markers
  let reformattedText = rawText.replace(/```html/g, '');
  reformattedText = reformattedText.replace(/```/g, '\r\n\r\n');

  // Clean / sanitize text
  const sanitizedText = sanitizeMarkdownText(reformattedText);

  // Parse to HTML
  return mdParser.render(sanitizedText);
}
